<template>
  <a-drawer
    :title="title"
    :visible="visible"
    :width="900"
    :maskClosable="true"
    placement="right"
    @close="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" class="rate-form">
        <a-form-item
          label="产品代码"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            show-search
            style="width: 300px"
            placeholder="请选择产品代码"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="value => handleSearch(value)"
            @change="codeChange"
            v-decorator="[
              'fundCode',
              {
                rules: [{ required: true, message: '请选择产品代码' }]
              }
            ]"
          >
            <a-select-option
              v-for="(item, index) in fundCodeList"
              :key="item.fundCode + '_' + index"
            >
              {{ item.fundCode }}/{{ item.fundName }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="费率类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @change="rateTypeChange"
            size="large"
            placeholder="请选择费率类型"
            style="width: 300px"
            v-decorator="[
              'rateType',
              {
                rules: [{ required: true, message: '请选择费率类型' }]
              }
            ]"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, value) in rate_type"
              :key="value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          v-if="showFeeType"
          label="收费方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            v-decorator="[
              'feeType',
              {
                rules: [{ required: true, message: '请选择收费方式' }]
              }
            ]"
          >
            <a-radio :value="1"> 前端 </a-radio>
            <a-radio :value="2"> 后端 </a-radio>
            <a-radio :value="3"> 场内 </a-radio>
            <a-radio :value="4"> 场外 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="计算方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            @change="gradeChange"
            size="large"
            placeholder="请选择计算方式"
            style="width: 300px"
            v-decorator="[
              'intervalType',
              {
                rules: [{ required: true, message: '请选择计算方式' }]
              }
            ]"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, value) in interval_type"
              :key="value"
            >
              {{ item.text }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- <a-form-item
          label="优惠费率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            size="large"
            style="width: 300px"
            placeholder="请输入费率"
            v-decorator="['preferredRate']"
          ></a-input>
        </a-form-item> -->
        <a-form-item
          v-if="gradeType != 2"
          label="费率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-if="gradeType == 4"
            style="width: 300px"
            v-decorator="[
              'rate',
              {
                rules: [{ required: true, message: '请输入费率' }]
              }
            ]"
            placeholder="请输入费率"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
          <a-input-number
            v-else
            size="large"
            style="width: 300px"
            placeholder="请输入费率"
            v-decorator="[
              'rate',
              {
                rules: [{ required: true, message: '请输入费率' }]
              }
            ]"
          ></a-input-number>
          <span
            style="font-size: 18px;
    padding-left: 10px;"
            >%</span
          >
        </a-form-item>

        <div v-if="gradeType == 2">
          <div
            v-for="(domain, index) in dynamicValidateForm.rateBracketList"
            :key="domain.key"
            class="dynamic-content"
          >
            <a-form-item label="分档区间" class="rate-item">
              <a-input
                placeholder="条件"
                v-decorator="[
                  'rateBracketList.' + index + '.gradeInterval',
                  {
                    initialValue: domain.gradeInterval,
                    rules: [{ required: true, message: '请输入条件' }],
                    trigger: 'blur'
                  }
                ]"
              />
            </a-form-item>
            <a-form-item label="费率" class="rate-item">
              <a-input
                placeholder="费率"
                v-decorator="[
                  'rateBracketList.' + index + '.rate',
                  {
                    initialValue: domain.rate,
                    rules: [{ required: true, message: '请输入费率' }],
                    trigger: 'blur'
                  }
                ]"
              />
            </a-form-item>
            <a-form-item label="索引" class="rate-item">
              <a-input-number
                :min="1"
                id="inputNumber"
                v-decorator="[
                  'rateBracketList.' + index + '.sortIndex',
                  {
                    initialValue: domain.sortIndex,
                    rules: [{ required: true, message: '请输入索引' }],
                    validateTrigger: 'blur'
                  }
                ]"
              />
              <a-icon
                v-if="dynamicValidateForm.rateBracketList.length > 1"
                class="dynamic-delete-button"
                type="minus-circle-o"
                :disabled="dynamicValidateForm.rateBracketList.length === 1"
                @click="removeDomain(domain)"
              />
            </a-form-item>
          </div>

          <div style="width: 200px; margin: 0 auto 30px">
            <a-button type="dashed" style="width: 200px" @click="addDomain">
              <a-icon type="plus" /> 添加分档详情
            </a-button>
          </div>
          <div class="rate-title">
            <span>分档描述</span>
            <span class="red-tip"
              >（费率：0~100间的小数，如3代表3%；100~代表固定金额，如1000代表1000/笔）</span
            >
          </div>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { addRate, editRate } from '@/api/rate.js';
import { getAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JUpload from '@/components/jeecg/JUpload';

export default {
  name: 'bonusManageModal',
  components: {
    JDictSelectTag,
    JImageUpload,
    JUpload
  },
  props: ['rate_type', 'fundList'],
  data() {
    return {
      rateType: '',
      form: this.$form.createForm(this),
      title: '修改',
      width: 1000,
      visible: false,
      model: {},
      fee_type: [],
      id: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      dynamicValidateForm: {
        rateBracketList: []
      },
      showFeeType: false,
      code: '',
      gradeType: '', //计算方式
      interval_type: [],
      fundCodeList: []
    };
  },
  created() {
    this.initData();
    this.fundCodeList = this.fundList;
  },
  watch: {
    fundList(val) {
      this.fundCodeList = val;
    }
  },
  methods: {
    //获取计算方式数据
    initData() {
      getAction(
        process.env.VUE_APP_CMS_SYSTEM + `/sys/dict/getDictItems/interval_type`,
        {}
      ).then(res => {
        if (res.success) {
          this.interval_type = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //计算方式 1、固定型-显示分档区间 2、范围型 3、说明型 - 普通费率
    gradeChange(val) {
      console.log(val);
      this.gradeType = val;
    },
    rateTypeChange(val) {
      this.rateType = val;
      // "基金申请费 首次认购费 日常赎回费 日常申购费 日常认购"
      if (val === '1' || val == '4' || val == '5' || val == '6' || val == '8') {
        this.showFeeType = true;
      } else {
        this.showFeeType = false;
      }
    },
    // codeChange(value, option) {
    //   let obj = this.fundList.find((item) => item.fundCode == value);
    //   if (obj) {
    //     this.$nextTick(() => {
    //       this.form.setFieldsValue({
    //         fundCode: obj.fundCode,
    //       });
    //     });
    //   }
    // },
    codeChange(value) {
      this.$nextTick(() => {
        this.form.setFieldsValue({
          fundCode: value.split('_')[0]
        });
      });
      this.fundCodeList = this.fundList;
    },
    removeDomain(item) {
      let index = this.dynamicValidateForm.rateBracketList.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.rateBracketList.splice(index, 1);
      }
    },
    addDomain() {
      console.log(this.dynamicValidateForm.rateBracketList, '>>>');
      this.dynamicValidateForm.rateBracketList.push({
        value: ''
        // key: Date.now()
      });
    },
    add() {
      this.visible = true;
      this.dynamicValidateForm.rateBracketList = [];
      this.gradeType = '';
      this.form.resetFields();
    },
    edit(record) {
      if (
        record.rateType == '1' ||
        record.rateType == '4' ||
        record.rateType == '5' ||
        record.rateType == '6' ||
        record.rateType == '8'
      ) {
        this.showFeeType = true;
      } else {
        this.showFeeType = false;
      }
      console.warn(record);
      this.code = record.code;
      // this.rateType = record.rateType;
      // this.dynamicValidateForm.rateBracketList = record.rateBracketList;
      this.dynamicValidateForm.rateBracketList =
        record.rateBracketList && record.rateBracketList != null
          ? record.rateBracketList
          : [];
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.gradeType = record.intervalType;
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'fundCode',
            'rateType',
            'rate',
            'preferredRate',
            'feeType',
            'sortIndex'
          )
        );

        this.form.setFieldsValue({
          rateType: record.rateType + '',
          intervalType: record.intervalType + ''
        });
      });
    },
    close() {
      this.$emit('close');
      this.dynamicValidateForm = { rateBracketList: [] };
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          //计算方式-范围型
          if (values.intervalType != 2) {
            this.confirmLoading = true;
            this.submit(values, '');
          } else {
            this.confirmLoading = true;
            this.submit(values, values.rateBracketList);
          }
        }
      });
    },
    submit(values, rateBracketList) {
      let formData = Object.assign(this.model, values);
      let obj = {
        ...formData,
        rateType: this.rateType
        // rateBracketList: rateBracketList ? rateBracketList : [],
      };
      obj.code = this.code;
      addRate(obj)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message);
            this.$emit('ok');
          } else {
            this.$message.warning(res.message);
          }
        })
        .finally(() => {
          this.confirmLoading = false;
          this.close();
        });
    },
    handleCancel() {
      this.close();
    },
    handleSearch(value) {
      let arr = [];
      this.fundList.forEach(item => {
        if (
          item.fundCode.indexOf(value) > -1 ||
          item.fundName.indexOf(value) > -1
        ) {
          arr.push(item);
        }
      });
      this.fundCodeList = arr;
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.rate-form {
  span.ver {
    margin-right: 26px;
    vertical-align: -34%;
  }
  .rate-item {
    display: inline-block;
    .ant-col {
      width: 100%;
    }
  }
  .rate-title {
    margin-bottom: 30px;
    text-align: center;
    .red-tip {
      color: red;
    }
    .ant-form-item {
      margin-bottom: 0;
    }
  }
  .rete-form-model {
    margin: 0 auto;
    padding-left: 30px;
    .lable-sa {
      label {
        color: #666;
        margin-right: 14px;
      }
    }
  }
}
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
.dynamic-delete-button {
  position: absolute;
  top: 0;
  left: 100px;
}
.dynamic-content {
  width: 100%;
  padding-left: 9%;
  display: flex;
  .rate-item {
    display: flex;
    margin-right: 10px;
  }
}
</style>
